import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "side-nav-outer-toolbar" }

import DxDrawer from "devextreme-vue/drawer";
import DxScrollView from "devextreme-vue/scroll-view";
import HeaderToolbar from "../components/layout/header-toolbar.vue";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import AcquaintNavMenu from "@/components/layout/acquaint-nav-menu.vue";
import UtilitySwitchingAgentNavMenu from "@/components/layout/utility-switching-agent-nav-menu.vue";
import UtilitySwitchingCouncilNavMenu from "@/components/layout/utility-switching-council-nav-menu.vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { AppMode } from "@/enums/system/AppMode";
import TenantSwitchingModal from "@/components/switches/tenant-switching/tenant-switching-modal.vue";
import LandlordSwitchingModal from "@/components/switches/landlord-switching/landlord-switching-modal.vue";
import PurchasingSwitchingModal from "@/components/switches/purchaser-switching/purchasing-switching-modal.vue";
import SurrenderCouncilSwitch from "@/components/switches/landlord-switching/surrender-council-switch.vue";
import CouncilPurchasingSwitchingModal from "@/components/switches/purchaser-switching/council-purchasing-switching-modal.vue";
import CouncilAllocationModal from "@/components/switches/tenant-switching/council-allocation-modal.vue";
import NewSupportCaseModal from "@/components/support-cases/new-support-case-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'side-nav-outer-toolbar',
  props: {
  title: String,
  isXSmall: Boolean,
  isSmall: Boolean,
  isLarge: Boolean,
},
  setup(__props) {

const props = __props;



const route = useRoute();

const scrollViewRef = ref<DxScrollView | null>(null);
const menuOpened = ref(props.isLarge);
const menuTemporaryOpened = ref(false);

function toggleMenu(e: any) {
  const pointerEvent = e.event;
  pointerEvent.stopPropagation();
  if (menuOpened.value) {
    menuTemporaryOpened.value = false;
  }
  menuOpened.value = !menuOpened.value;
}

function handleSideBarClick() {
  if (menuOpened.value === false) {
    menuTemporaryOpened.value = true;
  }
  menuOpened.value = true;
}

const drawerOptions = computed(() => {
  const shaderEnabled = !props.isLarge;

  return {
    menuMode: props.isLarge ? "shrink" : "overlap",
    menuRevealMode: props.isXSmall || props.isSmall ? "slide" : "expand",
    minMenuSize: props.isXSmall || props.isSmall ? 0 : 60,
    maxMenuSize: props.isXSmall || props.isSmall ? 250 : undefined,
    closeOnOutsideClick: shaderEnabled,
    shaderEnabled,
  };
});

watch(
  () => props.isLarge,
  () => {
    if (!menuTemporaryOpened.value) {
      menuOpened.value = props.isLarge;
    }
  },
);

watch(
  () => route.path,
  () => {
    if (menuTemporaryOpened.value || !props.isLarge) {
      menuOpened.value = false;
      menuTemporaryOpened.value = false;
    }

    scrollViewRef.value?.instance?.scrollTo(0);
  },
);

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const showTenantSwitchModal = ref(false);
const showLandlordSwitchModal = ref(false);
const showNewPurchaserSwitchModal = ref(false);
const openSurrenderModal = ref(false);
const showNewCouncilPurchaserSwitchModal = ref(false);
const showNewCouncilAllocationSwitchModal = ref(false);
const showNewSupportCaseModal = ref(false);
const acquaintDesktopPropertyId = ref(-1);
const acquaintDesktopContactId = ref(-1);
const acquaintDesktopTenancyId = ref(-1);

const openPurchaserSwitchFromDesktop = (
  contactId: number,
  propertyId: number,
) => {
  acquaintDesktopContactId.value = contactId;
  acquaintDesktopPropertyId.value = propertyId;
  showNewPurchaserSwitchModal.value = true;
};

const openTenantSwitchFromDesktop = (
  contactId: number,
  propertyId: number,
  tenancyId: number,
) => {
  acquaintDesktopContactId.value = contactId;
  acquaintDesktopPropertyId.value = propertyId;
  acquaintDesktopTenancyId.value = tenancyId;
  showTenantSwitchModal.value = true;
};

const openLandlordSwitchFromDesktop = (
  propertyId: number,
  tenancyId: number = -1,
) => {
  acquaintDesktopPropertyId.value = propertyId;
  acquaintDesktopTenancyId.value = tenancyId;
  showLandlordSwitchModal.value = true;
};

watch(
  () => showTenantSwitchModal.value,
  (newVal: boolean, oldVal: boolean) => {
    if (newVal === oldVal) {
      return;
    }

    // To prevent duplicate switches from being submitted, reset cached ids once the modal has been closed
    if (!newVal) {
      resetCachedDesktopIds();
    }
  },
);

watch(
  () => showLandlordSwitchModal.value,
  (newVal: boolean, oldVal: boolean) => {
    if (newVal === oldVal) {
      return;
    }

    // To prevent duplicate switches from being submitted, reset cached ids once the modal has been closed
    if (!newVal) {
      resetCachedDesktopIds();
    }
  },
);

watch(
  () => showNewPurchaserSwitchModal.value,
  (newVal: boolean, oldVal: boolean) => {
    if (newVal === oldVal) {
      return;
    }

    // To prevent duplicate switches from being submitted, reset cached ids once the modal has been closed
    if (!newVal) {
      resetCachedDesktopIds();
    }
  },
);

const resetCachedDesktopIds = () => {
  acquaintDesktopContactId.value = 0;
  acquaintDesktopPropertyId.value = 0;
  acquaintDesktopTenancyId.value = 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderToolbar, {
        class: "layout-header",
        "menu-toggle-enabled": true,
        "toggle-menu-func": toggleMenu,
        title: __props.title
      }, null, 8, ["title"]),
      _createVNode(_unref(DxDrawer), {
        class: "layout-body",
        position: "before",
        template: "menuTemplate",
        opened: menuOpened.value,
        "onUpdate:opened": _cache[7] || (_cache[7] = ($event: any) => ((menuOpened).value = $event)),
        "opened-state-mode": drawerOptions.value.menuMode,
        "reveal-mode": drawerOptions.value.menuRevealMode,
        "min-size": drawerOptions.value.minMenuSize,
        "max-size": drawerOptions.value.maxMenuSize,
        shading: drawerOptions.value.shaderEnabled,
        "close-on-outside-click": drawerOptions.value.closeOnOutsideClick
      }, {
        menuTemplate: _withCtx(() => [
          (currentUser.value?.appMode == _unref(AppMode).UtilitySwitchingAgent)
            ? (_openBlock(), _createBlock(UtilitySwitchingAgentNavMenu, {
                key: 0,
                "compact-mode": !menuOpened.value,
                onClick: handleSideBarClick,
                onTenantSwitchClick: _cache[0] || (_cache[0] = ($event: any) => (showTenantSwitchModal.value = true)),
                onPurchaserSwitchClick: _cache[1] || (_cache[1] = ($event: any) => (showNewPurchaserSwitchModal.value = true)),
                onLandlordSwitchClick: _cache[2] || (_cache[2] = ($event: any) => (showLandlordSwitchModal.value = true))
              }, null, 8, ["compact-mode"]))
            : (currentUser.value?.appMode == _unref(AppMode).UtilitySwitchingCouncil)
              ? (_openBlock(), _createBlock(UtilitySwitchingCouncilNavMenu, {
                  key: 1,
                  "compact-mode": !menuOpened.value,
                  onClick: handleSideBarClick,
                  onCouncilPurchaserSwitchClick: _cache[3] || (_cache[3] = ($event: any) => (
            showNewCouncilPurchaserSwitchModal.value = true
          )),
                  onCouncilAllocationSwitchClick: _cache[4] || (_cache[4] = ($event: any) => (
            showNewCouncilAllocationSwitchModal.value = true
          )),
                  onSurrenderClick: _cache[5] || (_cache[5] = ($event: any) => (openSurrenderModal.value = true))
                }, null, 8, ["compact-mode"]))
              : (_openBlock(), _createBlock(AcquaintNavMenu, {
                  key: 2,
                  "compact-mode": !menuOpened.value,
                  onClick: handleSideBarClick,
                  onCloseNavigationMenu: toggleMenu,
                  onTenantSwitchClick: openTenantSwitchFromDesktop,
                  onPurchaserSwitchClick: openPurchaserSwitchFromDesktop,
                  onLandlordSwitchClick: openLandlordSwitchFromDesktop,
                  onShowNewSupportCase: _cache[6] || (_cache[6] = ($event: any) => (showNewSupportCaseModal.value = true))
                }, null, 8, ["compact-mode"]))
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxScrollView), {
            ref_key: "scrollViewRef",
            ref: scrollViewRef,
            class: "with-footer"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default"),
              _renderSlot(_ctx.$slots, "footer")
            ]),
            _: 3
          }, 512)
        ]),
        _: 3
      }, 8, ["opened", "opened-state-mode", "reveal-mode", "min-size", "max-size", "shading", "close-on-outside-click"])
    ]),
    _createVNode(SurrenderCouncilSwitch, {
      modelValue: openSurrenderModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((openSurrenderModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(TenantSwitchingModal, {
      modelValue: showTenantSwitchModal.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showTenantSwitchModal).value = $event)),
      propertyId: acquaintDesktopPropertyId.value,
      contactId: acquaintDesktopContactId.value,
      tenancyId: acquaintDesktopTenancyId.value
    }, null, 8, ["modelValue", "propertyId", "contactId", "tenancyId"]),
    _createVNode(LandlordSwitchingModal, {
      modelValue: showLandlordSwitchModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showLandlordSwitchModal).value = $event)),
      propertyId: acquaintDesktopPropertyId.value,
      tenancyId: acquaintDesktopTenancyId.value
    }, null, 8, ["modelValue", "propertyId", "tenancyId"]),
    _createVNode(PurchasingSwitchingModal, {
      modelValue: showNewPurchaserSwitchModal.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showNewPurchaserSwitchModal).value = $event)),
      propertyId: acquaintDesktopPropertyId.value,
      contactId: acquaintDesktopContactId.value
    }, null, 8, ["modelValue", "propertyId", "contactId"]),
    _createVNode(CouncilPurchasingSwitchingModal, {
      modelValue: showNewCouncilPurchaserSwitchModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showNewCouncilPurchaserSwitchModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(CouncilAllocationModal, {
      modelValue: showNewCouncilAllocationSwitchModal.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showNewCouncilAllocationSwitchModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(NewSupportCaseModal, {
      modelValue: showNewSupportCaseModal.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((showNewSupportCaseModal).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})